!function () {
	var Translator = function () {
		this.init();
	};

	Translator.prototype = {
		constructor: Translator,

		init: function () {
			this.translationSet = {};

			this.setIsoCode($('html').attr('lang'));
		},

		addTranslationSet: function (isoCode, translationSet) {
			this.translationSet[isoCode] = translationSet;
			return this;
		},

		getTranslationSet: function (isoCode) {
			return this.translationSet[isoCode];
		},

		setIsoCode: function (isoCode) {
			this.isoCode = isoCode;
			return this;
		},

		getIsoCode: function () {
			return this.isoCode;
		},

		translate: function (string) {
			var translationSet = this.getTranslationSet(this.getIsoCode());
			return (typeof translationSet === 'undefined' || typeof translationSet[string] === 'undefined') ? string : translationSet[string];
		}
	};

	window.translator = new Translator();
	window.translator.addTranslationSet('fr-FR', {
		'__total__ program found' : '__total__ programme trouvé',
		'__total__ programs found' : '__total__ programmes trouvés',
		'No programs have been found for this search.' : 'Désolé, aucun programme correspondant à ces critères n’a été trouvé.',
		'No regions have been found.' : 'Désolé, aucune région n’a été trouvé.',
		'Viewing __partial__ of __total__ total programs' : '__partial__ de __total__ programmes trouvés',
		'Choose file' : 'Choisir le fichier',
		'Close': 'Fermer',
		'View Programs': 'Visionner les programmes',
		'There are no programs available yet.' : 'Il n\'y a pas de programmes disponibles.',
		// User device position detector
		'Geolocation Unsuccessful': 'Géolocalisation Échec',
		'To use the geolocation search feature, please allow Sportball to use your current location. Alternatively, search for your location using the search box.' : 'Pour utiliser la fonction de recherche de géolocalisation, svp laissez Sportball à utiliser votre emplacement actuel. Vous pouvez également rechercher l\'emplacement en utilisant la boîte de recherche.',
		'Your device position is not available at the moment. Try again later.' : 'Votre position de dispositif ne est pas disponible en ce moment. Réessayez plus tard svp.',
		'It took too long to retrieve your device position. Please try again.' : 'Il a fallu trop longtemps pour récupérer la position de votre appareil. Svp essayer de nouveau.',
		'An unspecified error has occurred while trying to retrieve your device position. Please try again later.' : 'Une erreur non spécifiée se est produite tout en essayant de récupérer la position de votre appareil. Svp réessayer plus tard.',
		// Google Maps geocodification
		'There was a problem contacting the Google servers. Please try again later.' : 'Il y avait un problème pour contacter les serveurs de Google. Svp réessayer plus tard.',
		'Invalid request sent to Google Maps.' : 'Une demande non valide a été envoyé à Google Maps.',
		'The maximum number of requests to Google Maps API has reached. Please try again later.' : 'Le nombre maximum de demandes à Google Maps API a atteint. Svp réessayer plus tard.',
		'Request denied. This page is not allowed in Google Maps to perform this request.' : 'Demande rejetée. Cette page ne est pas autorisé dans Google Maps pour effectuer cette demande.',
		'No results have been found for the specified address: ' : 'Aucun résultat a été trouvé pour l\'adresse indiquée: ',
		'No results have been found for the specified coordinates (latitude, longitude): ' : 'Aucun résultat a été trouvé pour les coordonnées spécifiées (latitude, longitude): ',
		'An unspecified error has occurred during the geo-codification. Please try again.' : 'Une erreur non spécifiée se est produite au cours de la géo-codification. Se il vous plaît essayer de nouveau.',
		'Problem loading program info,' : 'Problem loading program info,',
		'reload info.' : 'reload info.'
	});

}();
